import React from 'react';
import { Link } from 'react-router-dom';

const OrderNowButton = ({
  link = '/order-food',
  label = 'Order Now',
  buttonClass = 'order-button order-now-btn',
  containerClass = 'order-button-container text-center mt-20 order-now-btn-container',
  linkClass = 'order-now-btn-link',
  icon,
}) => {
  return (
    <div className={containerClass}>
      <Link to={link} className={linkClass}>
           <div className={buttonClass} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
             {icon && (
               <img src={icon} alt={label} style={{ height: 80, width: 80, marginBottom: 4, display: 'block' }} />
             )}
             <span style={{ display: 'block' }}>{label}</span>
           </div>
      </Link>
    </div>
  );
};

export default OrderNowButton;
